/**
 * セッション時刻ユーティリティ
 * サーバー時刻は UTC 基準として扱い、タイムゾーン未指定文字列も UTC として正規化する
 */

const dateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/;
const dateTimeStartsWithSpacePattern = /^\d{4}-\d{2}-\d{2} /;
const timezoneSuffixPattern = /(Z|[+-]\d{2}:\d{2})$/i;

/** サーバー時刻文字列を UTC ISO 文字列へ正規化する */
export function normalizeUtcDateTimeString(value: string): string | null {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  let normalizedValue = trimmedValue;
  if (dateOnlyPattern.test(normalizedValue)) {
    normalizedValue = `${normalizedValue}T00:00:00Z`;
  } else {
    if (dateTimeStartsWithSpacePattern.test(normalizedValue)) {
      normalizedValue = normalizedValue.replace(' ', 'T');
    }

    if (!timezoneSuffixPattern.test(normalizedValue)) {
      normalizedValue = `${normalizedValue}Z`;
    }
  }

  const parsedTime = Date.parse(normalizedValue);
  if (Number.isNaN(parsedTime)) {
    return null;
  }

  return new Date(parsedTime).toISOString();
}

/** サーバー時刻文字列を UTC としてミリ秒へ変換する */
export function parseUtcDateTime(value: string): number {
  const normalizedValue = normalizeUtcDateTimeString(value);
  return normalizedValue ? Date.parse(normalizedValue) : Number.NaN;
}

/** 同じ時刻を指しているかを UTC 基準で比較する */
export function hasSameUtcInstant(leftValue: string, rightValue: string): boolean {
  const leftTime = parseUtcDateTime(leftValue);
  const rightTime = parseUtcDateTime(rightValue);

  if (Number.isNaN(leftTime) || Number.isNaN(rightTime)) {
    return false;
  }

  return leftTime === rightTime;
}

/** UTC 時刻文字列をローカル時刻表示用へ整形する */
export function formatUtcDateTimeForDisplay(value: string): string {
  const parsedTime = parseUtcDateTime(value);
  if (Number.isNaN(parsedTime)) {
    return '';
  }

  const localDate = new Date(parsedTime);
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');
  const hours = String(localDate.getHours()).padStart(2, '0');
  const minutes = String(localDate.getMinutes()).padStart(2, '0');
  const seconds = String(localDate.getSeconds()).padStart(2, '0');

  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}
